import { CheckInUserPropertiesDto, CheckInVpvEventParamsDto } from "./vpv.dto";

export class CheckInInteractionsEventDto {
  event: string;
  event_params: CheckInInteractionsEventParamsDto;
  user_properties?: CheckInUserPropertiesDto;
}

export class CheckInInteractionsEventParamsDto extends CheckInVpvEventParamsDto {
  evento_interactivo_categoria: string;
  evento_interactivo_accion: string;
  evento_interactivo_etiqueta: string;
}
